import React from "react";
import { useTranslation } from "@helpers/translate";
import { CloseIcon } from "@components/library/Icons";
import forgotPassIcon from "@assets/img/forgot-pass-icon.svg";
import popupMobileBg from "@assets/img/popup-mobile.png";
import "../AuthForm.sass";
import "./CheckInbox.sass";

const CheckInbox = ({ setView, isMobile = false }) => {
  const { __ } = useTranslation();

  return (
    <div
      className={`auth-form${
        isMobile ? " auth-form--mobile auth-form--check-inbox-mobile" : ""
      }`}
      style={isMobile ? { backgroundImage: `url(${popupMobileBg})` } : {}}
    >
      <button
        type="button"
        onClick={() => setView("login")}
        className={`auth-form__check-inbox-close-button${
          isMobile ? " auth-form__check-inbox-close-button--mobile" : ""
        }`}
      >
        <CloseIcon className="h-5 w-5" />
      </button>
      <div
        className={`auth-form__check-inbox-content${
          isMobile ? " auth-form__check-inbox-content--mobile" : ""
        }`}
      >
        <img
          src={forgotPassIcon}
          alt="Check Inbox"
          className={`auth-form__check-inbox-icon${
            isMobile ? " auth-form__check-inbox-icon--mobile" : ""
          }`}
        />

        <h1
          className={`auth-form__check-inbox-title${
            isMobile ? " auth-form__check-inbox-title--mobile" : ""
          }`}
        >
          {__("auth.checkInbox")}
        </h1>

        <p
          className={`auth-form__check-inbox-text${
            isMobile ? " auth-form__check-inbox-text--mobile" : ""
          }`}
        >
          {__("auth.checkInboxDesc")}
        </p>
      </div>
    </div>
  );
};

export default CheckInbox;
